<template>
	<modal ref="modal">
		<template #title>{{action.toUpperCase()}} AFFILIATE LINK</template>
		<template #body>
			<div class="form-floating mb-4">
				<input v-model="form.source" type="text" id="source" name="source" class="form-control" placeholder="Source" />
				<label class="form-label" for="source">Source</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.description" type="text" id="description" name="description" class="form-control" placeholder="Description" />
				<label class="form-label" for="description">Description</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.category" type="text" id="category" name="category" class="form-control" placeholder="Category" />
				<label class="form-label" for="category">Category</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="form.web_link" type="text" id="web_link" name="web_link" class="form-control"  placeholder="Web Link"/>
				<label class="form-label" for="web_link">Web Link</label>
			</div>
			
			<div class="form-floating mb-4">
				<select v-model="form.status" id="status" name="status" class="form-control" placeholder="Status">
                  <option value="ON">ON</option>
                  <option value="OFF">OFF</option>
                </select>
				<label class="form-label" for="status">Status</label>
			</div>

		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Affiliate Link</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}
		
		const action = ref('add');

		const form = useForm({
			counter 		: 0,
			source 			: '',
			description 	: '',
			category 		: '',
			web_link 		: '',
			status 			: 'OFF'
		})

		const actionContent = ()=>{

			if(action.value=='add')
			{
				addAffLink();
			}else
			{
				updateAffLink();	
			}

		}

		const addAffLink = () => {
			form.post(route('admin.affiliate-program.post-affiliate-link'), {
				preserveState: true,
				preserveScroll: true,
				only:['affLinks,api_response','search'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateAffLink = () => {
			form.put('affiliate-link/'+form.counter, {
				preserveState: true,
				preserveScroll: true,
				only:['affLinks,api_response','search'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setAffLinkContent = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									form.counter 		= data.counter;
									form.source 		= data.source;
									form.description 	= data.description;
									form.category 		= data.category;
									form.web_link 		= data.web_link;
									form.status 		= data.status;
								}
								
							}


		return {
			form,
			modal,
			toggleModal,
			action,
			setAffLinkContent,
			actionContent,
			addAffLink,
			updateAffLink,
		}
	},
}
</script>
